import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/axiosSetup"; // JWT interceptor'larını kurar (App'ten önce)
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
